var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.68311H16.504C18.987 3.68311 21 5.69611 21 8.17911V17.1881C21 19.6701 18.987 21.6831 16.504 21.6831H7.496C5.013 21.6831 3 19.6701 3 17.1871V8.18311C3 5.69811 5.015 3.68311 7.5 3.68311V3.68311Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 10.3271H11.8986V16.4031H11.8966C10.6456 16.4031 9.27064 15.6431 8.29564 14.2431C6.83164 12.1911 6.43164 10.6401 6.43164 10.3281",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6583 16.4031C16.6583 16.4031 16.2163 15.4711 15.3193 14.4461C14.7213 13.7451 13.8793 13.3661 13.1133 13.3661C13.8793 13.3661 14.7213 12.9861 15.3193 12.2861C16.2163 11.2601 16.6583 10.3281 16.6583 10.3281",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1125 13.3672H11.8965",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.26201d2e1ab1146544ebc2490bf08aae.svg";
export { ForwardRef as ReactComponent };